<template>
  <v-chip color="grey lighten-3" close @click:close="toggleFilter">
    <abf-owner-avatar :user="owner"></abf-owner-avatar>
    <strong>{{ owner.full_name }}</strong>
  </v-chip>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';
import AbfOwnerAvatar from '@/components/Abf/AbfOwnerAvatar';

export default {
  name: 'owner-filter-chips',
  components: { AbfOwnerAvatar },
  data: () => ({
    filterChip: true
  }),
  props: ['ownerId'],
  computed: {
    ...mapGetters(['CustomerPageFilters', 'OwnersList']),
    owner: function() {
      const owners = this.OwnersList.map(({ id, full_name, roles }) => ({
        id,
        full_name,
        roles
      }));
      owners.push({
        id: null,
        full_name: 'Not Assigned',
        roles: []
      });
      return _.find(owners, ['id', this.ownerId]);
    }
  },
  methods: {
    ...mapActions(['removeOwnerFilter', 'getCustomerPage']),
    getPage: _.debounce(function() {
      this.getCustomerPage(false)
        .then(() => {})
        .catch(error => {
          console.log(error);
        });
    }, 250),
    toggleFilter() {
      this.removeOwnerFilter(this.owner).then(() => {
        this.getPage();
      });
    }
  },
  watch: {
    filterChip: function() {
      this.toggleFilter();
    }
  }
};
</script>

<style lang="scss" scoped>
div.input-group {
  padding-top: 0;
}
::v-deep .input-group__details {
  display: none;
}
</style>
